var _path, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolderSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
    fill: "#DEECFE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3924_42700",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3924_42700)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 16V22.025V22V32V16ZM17 34C16.45 34 15.9792 33.8042 15.5875 33.4125C15.1958 33.0208 15 32.55 15 32V16C15 15.45 15.1958 14.9792 15.5875 14.5875C15.9792 14.1958 16.45 14 17 14H25L31 20V22.5C30.6833 22.3667 30.3583 22.2625 30.025 22.1875C29.6917 22.1125 29.35 22.0583 29 22.025V21H24V16H17V32H23.025C23.2917 32.4 23.5917 32.7708 23.925 33.1125C24.2583 33.4542 24.625 33.75 25.025 34H17ZM28.5 31C29.2 31 29.7917 30.7583 30.275 30.275C30.7583 29.7917 31 29.2 31 28.5C31 27.8 30.7583 27.2083 30.275 26.725C29.7917 26.2417 29.2 26 28.5 26C27.8 26 27.2083 26.2417 26.725 26.725C26.2417 27.2083 26 27.8 26 28.5C26 29.2 26.2417 29.7917 26.725 30.275C27.2083 30.7583 27.8 31 28.5 31ZM33.6 35L30.9 32.3C30.55 32.5333 30.1708 32.7083 29.7625 32.825C29.3542 32.9417 28.9333 33 28.5 33C27.25 33 26.1875 32.5625 25.3125 31.6875C24.4375 30.8125 24 29.75 24 28.5C24 27.25 24.4375 26.1875 25.3125 25.3125C26.1875 24.4375 27.25 24 28.5 24C29.75 24 30.8125 24.4375 31.6875 25.3125C32.5625 26.1875 33 27.25 33 28.5C33 28.9333 32.9417 29.3542 32.825 29.7625C32.7083 30.1708 32.5333 30.55 32.3 30.9L35 33.6L33.6 35Z",
    fill: "#3A8AF7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderSearchIcon);
export default __webpack_public_path__ + "static/media/FolderSearchIcon.7ebf8b9b46263485b6c796fed468abfa.svg";
export { ForwardRef as ReactComponent };